export const STORE_CLEAR = 'STORE_CLEAR';
